import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import fb from "./firebaseConfig";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
export default new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  state: {
    reseller: null,
    loading: false,
    products: [],
    inventory: {},
    productListener() {},
    inventoryListener() {},
  },
  getters: {
    getReseller: (state) => {
      return state.reseller;
    },
  },
  mutations: {
    ...vuexfireMutations,
    setRes(state, reseller) {
      state.reseller = reseller;
    },
    clearRes(state) {
      state.reseller = null;
    },
    setLoading(state, status) {
      state.loading = status;
    },
  },
  actions: {
    setReseller: firestoreAction(async ({ bindFirestoreRef }) => {
      let resellers = await fb.db
        .collection("reseller_profile")
        .where("primary_contact_info.uid", "==", fb.auth.currentUser.uid)
        .get();
      let reseller_ref = resellers.docs[0].ref;
      return bindFirestoreRef("reseller", reseller_ref);
    }),
    clearReseller(context) {
      context.state.reseller = null;
      return context.dispatch('unBindReseller');
    },
    unBindReseller: firestoreAction(({ unbindFirestoreRef }) => {
      unbindFirestoreRef('reseller')
    }),
    saveReseller({ dispatch, commit }, reseller) {
      return fb.db
        .collection("reseller_profile")
        .doc(reseller.id)
        .set(reseller)
        .then((msg) => {
          dispatch.commit("setRes", reseller);
        })
        .catch((msg) => {
          return msg;
        });
    },
    async getProducts(context) {
      context.state.productListener();
      context.state.inventoryListener();
      if (fb.auth.currentUser) {
        let reseller = await fb.db
          .collection("reseller_profile")
          .where("primary_contact_info.uid", "==", fb.auth.currentUser.uid)
          .get();
        if (reseller.size) {
          let rid = reseller.docs[0].id;
          context.state.productListener = fb.db
            .collection(`reseller_profile/${rid}/products`)
            .onSnapshot((query) => {
              context.state.products = query.docs.map((d) =>
                Object.assign({ id: d.id }, d.data())
              );
            });
          context.state.inventoryListener = fb.db
            .collection(`reseller_profile/${rid}/inventory`)
            .onSnapshot((query) => {
              let inventory = {};
              query.docs.forEach((d) => {
                let unit = Object.assign({ id: d.id }, d.data());
                if (!inventory[unit.product_id]) {
                  inventory[unit.product_id] = [];
                }
                inventory[unit.product_id].push(unit);
              });
              context.state.inventory = inventory;
            });
        }
      } else {
        context.state.products = [];
        context.state.inventory = {};
      }
    },

    // signOut() {
    //   firebase.auth().signOut();
    // },
  },
});
